<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-data-table
        :headers="headers"
        :items="connections"
        :items-per-page="-1"
        :height="conentProps.tableHeight"
        tableProps.tableHeight
        fixed-header
        hide-default-footer
        :search="fastFilter"
        :custom-filter="customFilter">

        <template v-slot:[`item.application`]="{ item }">
          {{ item.application || "-" }}
        </template>
        <template v-slot:[`item.lastRequestTimestamp`]="{ item }">
          {{ formatDateTime(item.lastRequestTimestamp) }}
        </template>
      </v-data-table>
    </template>
  </ResizablePage>
</template>

<script>
//import Vue from "vue";
import ResizablePage from "@/components/ResizablePage";
import { DateTime } from "luxon";

export default {
  name: "ApiConnectionsView",
  components: { ResizablePage },
  data() {
    return {
      mounted: false,
      headers: [
        {
          text: this.$t("table.apiConnections.header.user"),
          align: "start",
          sortable: true,
          width: "20%",
          value: "name"
        },
        {
          text: this.$t("table.apiConnections.header.type"),
          align: "start",
          sortable: true,
          width: "16%",
          value: "authorizationType"
        },
        {
          text: this.$t("table.apiConnections.header.application"),
          align: "start",
          sortable: true,
          width: "16%",
          value: "application"
        },
        {
          text: this.$t("table.apiConnections.header.company"),
          align: "start",
          sortable: true,
          width: "16%",
          value: "companyCode"
        },
        {
          text: this.$t("table.apiConnections.header.ip"),
          align: "start",
          sortable: true,
          width: "16%",
          value: "remoteAddress"
        },
        {
          text: this.$t("table.apiConnections.header.timestamp"),
          align: "start",
          sortable: true,
          width: "16%",
          value: "lastRequestTimestamp"
        }
      ]
    };
  },
  computed: {
    fastFilter: function() {
      return this.$store.state.data.fastFilter;
    },
    connections: function() {
      return this.$store.state.data.records.map(x => {
        return {
          authorizationType: x.authorizationType,
          name: x.firstName + ' ' + x.lastName,
          application: x.application,
          companyCode: x.companyCode,
          remoteAddress: x.remoteAddress,
          lastRequestTimestamp: x.lastRequestTimestamp
        };
      });
    }
  },
  methods: {
    customFilter(value, search, item) {
      let ls = search.toLocaleString();
      return (item.name !== null && item.name.toLowerCase().includes(ls))
        || (item.companyCode !== null && item.companyCode.toLowerCase().includes(ls))
        || (item.remoteAddress !== null && item.remoteAddress.toLowerCase().includes(ls));
    },
    formatDateTime(dt) {
      return DateTime.fromISO(dt).toLocaleString(DateTime.DATETIME_SHORT)
    }
  },
  mounted() {
    this.mounted = true;
    this.$store.dispatch("data/fetchRecords", { module: "api-connection" });
  },
  destroyed() {
    this.mounted = false;
  }
};
</script>

<style lang="sass" scoped>
.normal-flag-move
  margin: -10px -5px !important
</style>